import { isElement } from 'react-is';
import { ReactElement, ReactNode } from 'react'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function MarkdownParagraph(props: any) {
	const { children } = props;

	if (isImageParagraph(children)) {
		// Render images without paragraph wrapper (full-width)
		return children;
	}

	return <p>{children}</p>;
}

function isImageParagraph(input: ReactNode) {
	if (isSingleImageElement(input)) return true;

	return isSingleLinkWithSingleImageElement(input);
}

function isSingleImageElement(input: ReactNode) {
	const singleElement = validateSingleReactElement(input);

	if (!singleElement) return false;

	return isImageElement(singleElement);
}

function validateSingleReactElement(
	input: ReactNode,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): ReactElement<any, any> | undefined {
	if (!Array.isArray(input)) return validateReactElement(input);

	if (input.length !== 1) return undefined;

	return validateReactElement(input[0]);
}

function validateReactElement(
	input: ReactNode,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): ReactElement<any, any> | undefined {
	return isElement(input) ? input : undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isImageElement(input: ReactElement<any, any>) {
	return 'src' in input.props;
}

function isSingleLinkWithSingleImageElement(input: ReactNode) {
	const singleElement = validateSingleReactElement(input);

	if (!singleElement || !isLinkElement(singleElement)) return false;

	const { children } = singleElement.props;

	const singleChildElement = validateSingleReactElement(children);

	return !!singleChildElement && isImageElement(singleChildElement);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isLinkElement(input: ReactElement<any, any>) {
	return 'href' in input.props;
}
